module.exports = __webpack_public_path__ + "static/media/1001017.0a082598.png";